import React from "react";
import PopoverEmployeeProfile from "./PopoverEmployeeProfile";
import "./EmployeeAvatar.css";
import { getDefaultUserAvatar } from "winslow-core";
import { useSelector } from "react-redux";
import { selectEmployeeProfileFromCache } from "../../redux/features/appData";
import { useValidatedImageUrl } from "../../hooks/useValidatedImageUrl";

export type EmployeeAvatarProps = {
  email: string | null;
  avatarUrl: string | null | undefined;
  name: string | null;
};

export const EmployeeAvatar = ({
  email,
  avatarUrl,
  name,
}: EmployeeAvatarProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const employeeProfile = useSelector(
    selectEmployeeProfileFromCache(email || "")
  );
  const employeeAvatarUrl = employeeProfile?.avatar || avatarUrl;
  const fallbackAvatar = getDefaultUserAvatar(name || "");
  const { validatedUrl, isValidating } = useValidatedImageUrl(
    employeeAvatarUrl || "",
    fallbackAvatar
  );

  return (
    <>
      {email && name && employeeAvatarUrl && (
        <PopoverEmployeeProfile avatar={validatedUrl} name={name} email={email}>
          <div onClick={handleClick}>
            {isValidating ? (
              <div className="author-avatar avatar-loading">...</div>
            ) : (
              <img
                src={validatedUrl}
                alt={name || "Avatar"}
                className="author-avatar"
              />
            )}
          </div>
        </PopoverEmployeeProfile>
      )}
      {!email && (
        <>
          {isValidating ? (
            <div className="author-avatar avatar-loading">...</div>
          ) : (
            <img
              src={validatedUrl}
              alt={name || "Avatar"}
              className="author-avatar"
            />
          )}
        </>
      )}
    </>
  );
};
